import { useImportContext } from '../../../../../../components/csv-import/ui/components/import-context';
import { MappingImportStepFooter } from './sub-steps/mapping-import-step';

export const MappingStepFooter = () => {
  const { onClose } = useImportContext();
  return <MappingImportStepFooter onPrevClick={onClose} />;
};
